// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ArrowBackIos } from '@material-ui/icons';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { BlockContainer, Loader } from '../../../../../../../components';
import { VoucherInfo, Books } from '../components';

import styles from './styles';

import * as voucherDetailsActions from '../store/actions';
import {
  getLoader,
  getVoucher,
} from '../store/selectors';

import globalHistory from '../../../../../../../services/history';

class VoucherDetails extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    loading: PropTypes.bool,
    voucher: PropTypes.object,

    getVoucher: PropTypes.func,
  };

  static defaultProps = {
    classes: {},
    history: {},
    match: {},
    loading: false,
    voucher: {},

    getVoucher: () => { },
  };

  componentDidMount() {
    const CustomerId = localStorage.getItem('loggedID');
    const Token = localStorage.getItem('token');
    const { history, match } = this.props;

    // The :id in the path first, with the router state the Link carries as a
    // fallback. Reading state alone blanked the page on a reload or a pasted
    // link - state only exists when you arrive by clicking - the same way the
    // full-order screen used to. Fixed here to make the date visible for a
    // direct visit at all.
    const voucherId = (match && match.params && match.params.id)
      || ((history.location.state || {}).voucherId);

    this.props.getVoucher({
      CustomerId,
      Token,
      VoucherId: voucherId,
    });
  }

  render() {
    const {
      classes,
      loading,
      voucher,
    } = this.props;

    return (
      <div className={classes.root}>
        {loading
          ? (
            <div className={classes.loaderContainer}>
              <Loader />
            </div>
          ) : (
            <div>
              <div
                role={'button'}
                tabIndex={0}
                onKeyPress={() => globalHistory.goBack()}
                onClick={() => globalHistory.goBack()}
                className={classes.arrowBackContainer}
              >
                <ArrowBackIos className={classes.link} />
                <div className={classes.link}>Back</div>
              </div>
              <div className={classes.blockContainer}>
                <BlockContainer
                  topText={'Voucher'}
                  bottom={<VoucherInfo voucher={voucher.Voucher} />}
                />
              </div>
              <div className={classes.blockContainer}>
                <BlockContainer
                  topText={'Voucher items'}
                  bottom={<Books books={voucher.Details} />}
                />
              </div>
            </div>)
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: getLoader(state),
    voucher: getVoucher(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getVoucher: payload => dispatch(voucherDetailsActions.getVoucher(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(VoucherDetails));
